import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

const BEM_BLOCK: string = 'sc-calc-shell';

@Component({
    selector: 'sc-calc-shell',
    template: '<router-outlet />',
    styles: `
        :host {
            display: flex;
            width: 100%;
            height: 100%;
            flex-direction: column;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterOutlet],
    host: {
        class: BEM_BLOCK,
    },
})
export default class CalcShellComponent {}
